import dayjs, { Dayjs } from "dayjs";
import { MONTHS, READABLE_DATE_OPTIONS } from "../variables/constants";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const toReadableFormat = (
  date: string,
  dateFormat?: object,
  locale?: string
) =>
  new Intl.DateTimeFormat(
    locale ?? "en-US",
    dateFormat ?? READABLE_DATE_OPTIONS
  ).format(new Date(date));

export const transactionDateFormat = (date: Dayjs) =>
  dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSSZ");

export const formatDateToISOString = (date: number): string => {
  const formattedDate = new Date(date).toISOString();
  return formattedDate.slice(0, -1);
};

export const formatToMonthYear = (month: number, year: string) => {
  const abbreviatedMonth = MONTHS[month - 1].slice(0, 3).toUpperCase();
  return `${abbreviatedMonth} ${year}`;
};

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${month}-${day}-${year}`;
};

export const convertToLocal = (date: string | number | dayjs.Dayjs | Date | null | undefined) => {
  const utcDate = dayjs.utc(date);
  return utcDate.local();
};

export const convertToLocalWithoutUTC = (date: string | number | dayjs.Dayjs | Date | null | undefined) => {
  return dayjs(date);
};
export const convertToLocalYYYY_MM_DD = (date: string | number | dayjs.Dayjs | Date | null | undefined) => {
  return dayjs(date).format("YYYY-MM-DD");
};
